'use strict';

export Button from './button';
export Icon from './icon';
export Dropdown from './dropdown';
export Table from './table';
export Pagination from './pagination';
export Radio from './radio';
export Checkbox from './checkbox';
export Tabs from './tabs';
export {Input, Number } from './input';
export Section from './section';

export message from './message';
export Tooltip from './tooltip';
export Modal from './modal';

/* begin --- import antd component **/
export Row from 'antd/lib/row';
export Col from 'antd/lib/col';
export Menu from 'antd/lib/menu';
export Form from 'antd/lib/form';
export Layout from 'antd/lib/layout';
/* endt --- import antd component **/



// WEBPACK FOOTER //
// ./src/index.js